'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:account:sendMobileLoginCode');
}

var _invoke = require('../invoke');

/**

 *
 * 支持版本
 * + iHotel/6.2
 *
 * @memberof account
 * @static
 * @name sendMobileLoginCode
 * @param {String} mobile 手机号
 * @returns {Promise<user>} resolve if login success
 * @example
 *  hbnb.account.sendMobileLoginCode('19988887777')
 *      .then(function() {
 *      })
 *      .catch(function() {
 *      })
 */

module.exports = function(mobile) {
    var p = new Promise(function(resolve, reject) {
        _invoke('user', 'send_mobile_login_code', {
            mobile: mobile,
            callback: function() {
                resolve();
            },
            errback: reject
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/hbnb/account/send-mobile-login-code.js
// module id = vYff
// module chunks = 0